import React, { useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { registerAccount } from "services/auth_service";
import config from "config.json";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

import "css/main.css";
import "css/style.css";
import "external/fontawesome/css/all.css";

const ERROR_MESSAGE_MIN_AGE =
  "Tens menos de 13 anos? Envia um email diretamente para geral@footsolution.pt para que te possamos ajudar a registar na plataforma";

function App({ setActiveTab }) {
  const { t } = useTranslation();

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [offerType, setOfferType] = useState(null);
  const [dateofbirth, setDateofbith] = useState(null);
  const [cookiesPolicy, setCookiePolicy] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [position, setPosition] = useState(null);

  const { register, handleSubmit, control } = useForm({});

  const changeDateValue = (value) => {
    setErrorMsg("");

    if (moment().diff(value, "years", false) < 13) {
      setErrorMsg(ERROR_MESSAGE_MIN_AGE);
    }

    setDateofbith(value);
  };

  const changeTab = () => {
    setActiveTab("login");
  };

  const submitRegister = async (data) => {
    if (!data.password) {
      // strange bug that sometimes would invoke this with the event instead of the data causing the function to fail.
      // use data.password to validate that the data is passing the correct value
      return;
    }
    if (data.repeatPass !== data.password) {
      setErrorMsg(
        "A password e o campo repetir password teem que ter o mesmo valor"
      );
      return;
    }
    if (!dateofbirth && offerType !== "Clube") {
      setErrorMsg("Por favor preencha a data de nascimento.");
      return;
    }
    else if (dateofbirth && offerType !== "Clube") {
      data.date_of_birth = moment(dateofbirth).format("YYYY-MM-DD");
    }
    
    if (offerType === "Jogador" && (!position || position.length === 0)) {
      setErrorMsg("Por favor selecione pelo menos uma posição.");
      return;
    }

    if (offerType === "Jogador" && position.length > 3) {
      setErrorMsg("Só pode selecionar no máximo 3 posições.");
      return;
    }

    if (!cookiesPolicy) {
      setErrorMsg("Por favor concorde com a política de cookies.");
      return;
    }

    if (!privacyPolicy) {
      setErrorMsg("Por favor concorde com a política de privacidade.");
      return;
    }

    if (
      offerType !== "Clube" &&
      moment().diff(dateofbirth, "years", false) < 13
    ) {
      setErrorMsg(ERROR_MESSAGE_MIN_AGE);
      return;
    }

    try {
      if (offerType === "Jogador") {
        data.position = position;
      }
      await registerAccount(data);
      setSuccessMsg(
        "Registou-se com sucesso. Por favor confirme o seu email e depois faça o login."
      );
      setErrorMsg("");
      return;
    } catch (exception) {
      setSuccessMsg("");
      if (
        exception?.response?.data?.error?.message ==
        "Email or Username are already taken"
      ) {
        setErrorMsg("O Email já se encontra registado na plataforma.");
        return;
      }

      setErrorMsg(
        "Erro inesperado, por favor entre em contacto com a nossa equipa"
      );
    }
  };

  return (
    <div className="App">
      <section className="section" style={{ padding: "0" }}>
        <div className="block">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to={"/login"} onClick={() => changeTab("login")}>
                  Login
                </Link>
              </li>
              <li className="is-active">
                <Link to={"/login"} aria-current="page">
                  &nbsp;&nbsp;{t("register")}
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="block">
          <h3 className="title is-4">{t("register_initial_text")}</h3>
          <p></p>
        </div>

        <form onSubmit={handleSubmit((data) => submitRegister(data))}>
          <div className="block">
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <select
                  // Set refresh to force the placeholder for name to change
                  className="input"
                  type="text"
                  {...register("role", {
                    required: true,
                  })}
                  onChange={(event) => {
                    setOfferType(event.target.value);
                  }}
                >
                  <option value="" disabled selected>
                    Tipo de conta
                  </option>

                  {config.ACCOUNT_ROLES.map((el, idx) => (
                    <option key={idx} value={el.value}>
                      {el.label}
                    </option>
                  ))}
                </select>
                <span className="icon is-small is-left">
                  <i style={{ zIndex: "0" }} className="fas fa-cogs"></i>
                </span>
              </p>
            </div>
          </div>
          {offerType === "Clube" && (
            <div className="block">
              <div className="field">
                <label className="label">Nome do Clube</label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Select
                      options={config.CLUB_OPTIONS}
                      onChange={(val) => {
                        onChange(val.value);
                      }}
                      value={config.CLUB_OPTIONS.find((c) => c.value === value)}
                    />
                  )}
                />
              </div>
            </div>
          )}
          {offerType === "Jogador" && (
            <div className="block">
              <div className="field">
                <Select
                  isMulti
                  options={config.POSITIONS_PLAYER}
                  value={config.POSITIONS_PLAYER.filter(option => position?.includes(option.value))}
                  onChange={(selectedOptions) => {
                    if (selectedOptions.length <= 3) {
                      setPosition(selectedOptions.map(option => option.value));
                    }
                  }}
                  placeholder="Escolhe a tua posição (max. 3)"
                />
              </div>
            </div>
          )}
          {offerType !== "Clube" && (
            <div className="block">
              <div className="field">
                <p className="control has-icons-left has-icons-right">
                  <input
                    className="input"
                    type="text"
                    {...register("name", {
                      required: true,
                    })}
                    placeholder={"Nome"}
                  />

                  <span className="icon is-small is-left">
                    <i className="fas fa-user"></i>
                  </span>
                </p>
              </div>
            </div>
          )}
          {offerType && offerType !== "Clube" && (
            <div className="block">
              <div className="field">
                <p className="control">
                  <DatePicker
                    scrollableYearDropdown
                    yearDropdownItemNumber={30}
                    className="input"
                    selected={dateofbirth}
                    value={dateofbirth}
                    onChange={(value) => {
                      changeDateValue(value);
                    }}
                    dateFormat="dd/MM/yyyy"
                    showYearDropdown
                    placeholderText={"Data de nascimento"}
                    dropdownMode="select"
                  />
                </p>
              </div>
            </div>
          )}
          <div className="block">
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <input
                  className="input"
                  type="email"
                  {...register("email", {
                    required: true,
                  })}
                  placeholder="Email"
                />

                <span style={{ zIndex: "0" }} className="icon is-small is-left">
                  <i className="fas fa-envelope"></i>
                </span>
              </p>
            </div>
          </div>
          <div className="block">
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <input
                  className="input"
                  type="password"
                  {...register("password", {
                    required: true,
                  })}
                  placeholder="Password"
                />
                <span style={{ zIndex: "0" }} className="icon is-small is-left">
                  <i className="fas fa-key"></i>
                </span>
              </p>
            </div>
          </div>
          <div className="block">
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <input
                  className="input"
                  type="password"
                  {...register("repeatPass", {
                    required: true,
                  })}
                  placeholder="Repeat-Password"
                />
                <span style={{ zIndex: "0" }} className="icon is-small is-left">
                  <i className="fas fa-key"></i>
                </span>
              </p>
            </div>
          </div>

          <div className="block">
            <div className="field">
              <label className="checkbox">
                <input type="checkbox" onClick={() => setCookiePolicy(!cookiesPolicy) } />
                Concordo com a{" "}
                <a
                  href="https://www.footsolution.pt/politica-cookies"
                  target="_blank"
                >
                  política de cookies
                </a>
                .
              </label>

              <label className="checkbox">
                <input type="checkbox" onClick={() => setPrivacyPolicy(!privacyPolicy) }/>
                Concordo com a{" "}
                <a
                  href="https://www.footsolution.pt/política-privacidade"
                  target="_blank"
                >
                  política de privacidade
                </a>
                .
              </label>
            </div>
          </div>
          <div className="block">
            <button
              className="button btn1 is-link is-fullwidth"
              type="submit"
              onClick={submitRegister}
            >
              {t("send")}
            </button>
          </div>
        </form>
        <div className="block"> </div>

        {successMsg !== "" && (
          <div className="block">
            <article className="message is-success">
              <div className="message-body">{successMsg}</div>
            </article>
          </div>
        )}

        {errorMsg !== "" && (
          <div className="block">
            <article className="message is-warning">
              <div className="message-body">{errorMsg}</div>
            </article>
          </div>
        )}
      </section>
    </div>
  );
}

export default App;
